import { isMockEnabled } from './isEnabled';
import { handleMikasaRequest, isMikasaUrl } from './mikasa';
import { installRecurlyMock } from './recurly';

let installed = false;

export const installMocksIfEnabled = () => {
  if (installed || !isMockEnabled() || typeof window === 'undefined') {
    return;
  }

  installRecurlyMock();

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const url = typeof input === 'string' ? input : input?.url;
    if (url && isMikasaUrl(url)) {
      return Promise.resolve(handleMikasaRequest(url, init));
    }
    return originalFetch(input, init);
  };

  installed = true;
  console.info('[signup mocks] Mikasa and Recurly are mocked. Set REACT_APP_MOCK_APIS=false to use live APIs.');
};

export { isMockEnabled } from './isEnabled';
